module.exports = __webpack_public_path__ + "static/media/check.235701a7.svg";